// 用户行为 0访问 1复制 2点击 3曝光
export const DEED_MAP = {
  VISITED: 0,
  COPY: 1,
  CLICK: 2,
  EXPOSURE: 3,
};
// 事件编号
export const OID_MAP = {
  HOME_PAGE_VISITED: 2000, //首页曝光
  LOGIN_POPUP_EXPOSURE: 2001, //注册弹框曝光
  ENTERPRISE_PACKAGE_CLICK: 2002, //企业套餐点击
  ABOUT_US_QLM_CLICK: 2003, //关于千里马点击
  HEADER_REGISTER_CLICK: 2004, //顶部注册按钮点击
  HEADER_LOGIN_CLICK: 2005, //顶部登录按钮点击
  HEADER_MEMBER_CLICK: 2006, //顶部会员中心按钮点击
  HOME_SEARCH_CLICK: 2007, //点击搜索顶栏，搜索框，热搜关键词
  LATEST_BILLBOARD_TAB_CLICK: 2008, //最新标讯tab点击
  LATEST_BILLBOARD_LINK_CLICK: 2009, //最新标讯任意链接
  ENTERPRISE_PACKAGE_PAGE_VISITED: 2010, //企业套餐页面曝光
  VIP_LOGIN_PAGE_VISITED: 2011, //登录页面曝光
  BANNER_LOGIN_CLICK: 2019, //banner登录按钮点击

  PRODUCTS_SERVICES_PAGE_VISITED: 2033, //产品服务页曝光 2033
  PRODUCTS_SERVICES_HEADER_BOX_EXPOSURE: 2034, //产品服务顶部框曝光2034
  PRODUCTS_SERVICES_BILLBOARD_CLICK: 2020, //产品服务模块-招标查询：2020
  PRODUCTS_SERVICES_VIP_CLICK: 2021, //产品服务模块-VIP独家信息：2021
  PRODUCTS_SERVICES_PROJECT_CLICK: 2022, //产品服务模块-拟在建项目查询：2022
  PRODUCTS_SERVICES_BUSINESS_OPPORTUNITY_PUSH_CLICK: 2023, //产品服务模块-商机推送：2023
  PRODUCTS_SERVICES_COMPANY_ANALYSE_RIGHT_CLICK: 2035, //产品服务模块-企业商情分析：2035
  PRODUCTS_SERVICES_ENTERPRISE_INTELLIGENT_MANAGEMENT_CLICK: 2024, //产品服务模块-企业智能管理：2024
  PRODUCTS_SERVICES_PUBLISH_BIDDING_CLICK: 2025, //产品服务模块-发布招标信息：2025
  PRODUCTS_SERVICES_RECOMMEND_BIDDING_CLICK: 2026, //产品服务模块-推荐招标专区：2026
  PRODUCTS_SERVICES_FINDING_CONNECTIONS_CLICK: 2027, //产品服务模块-找人脉：2027
  PRODUCTS_SERVICES_TUO_KE_BAO_CLICK: 2028, //产品服务模块-拓客宝：2028
  PRODUCTS_SERVICES_REN_MAI_TONG_CLICK: 2029, //产品服务模块-人脉通：2029
  PRODUCTS_SERVICES_QU_DAO_BAO_CLICK: 2030, //产品服务模块-渠道宝：2030
  PRODUCTS_SERVICES_DATA_MALL_CLICK: 2031, //产品服务模块-数据商城：2031
  PRODUCTS_SERVICES_DATA_CUSTOMIZED_CLICK: 2032, //产品服务模块-数据定制：2032

  FUNCTION_NAVIGATION_CLICK: 2058, //功能导航栏点击
  INFORMATION_IMPROVE_EXPOSURE: 2076, //完善信息页曝光
  INFORMATION_IMPROVE_CANCEL_CLICK: 2077, //完善信息页-放弃按钮单击
  INFORMATION_IMPROVE_CONFIRM_CLICK: 2078, //完善信息页-确认按钮单击

  BOTTOM_BANNER_LOGIN_BTN_CLICK: 2079, //底部banner登录按钮
  DETAIL_ENTERPRISE_INFORMATION_POPUP: 2080, // 详情页-企业信息弹窗
  NEW_HOME_REGISTER:2123,//注册统计
  
};
